import React, { useEffect, useRef, useState } from 'react'
import exampleImage from '../../img/example.png'
import FullCalendar from '@fullcalendar/react'
import { CalendarContainer } from '../../components/CalendarView'
import useAccountStore from '../../stores/account'
import axios from 'axios'
import useEstimateStore from '../../stores/estimate'
import { BASEURL } from '../../config'
import { db } from '../../config/firebase'
import { addDoc, collection } from 'firebase/firestore'

const MainPage = (props:any) => {
    const {accessToken} = useAccountStore()
    const {estimateList} = useEstimateStore()

    const [curEsti, setEstimate] = useState<any|null>(null)
    const [events, setEvents] = useState<any[]>([])
    const [visible, setVisible] = useState(false)
    const calendarRef = useRef<FullCalendar>(null)

    const male = '남'
    const female = '여'
    const neuteredMale = '중성화 남'
    const neuteredFemale = '중성화 여'
    const genderMap: { [key: string]: number } = { [male]: 1, [female]: 2, [neuteredMale]: 3, [neuteredFemale]: 4 }

    const addReservationAtCalendar = () => {
        const createEvent = (title:string, date:Date, estID:number) => {
            return { title: title, 
                     start:  new Date(date.getFullYear(),
                     date.getMonth(), date.getDate(), 
                     date.getHours(), date.getMinutes()),
                     estID: estID }
        }

        let event_list:any[] = []

        for(const esti of estimateList){
            if(esti.status === "reserved"){
                const tit:string = `${esti.userInfo?.petName} (${Object.keys(genderMap).find(key => genderMap[key] === esti?.userInfo?.petGender) ?? "구분없음"})`
                event_list.push(createEvent(tit, new Date(esti.createdAt), esti.id))
            }
        }
        
        setEvents(event_list)
    }

    useEffect(()=> { addReservationAtCalendar()},[estimateList])
    useEffect(() => {
        const infoDiv = document.querySelector('.info') as HTMLDivElement

        if (infoDiv !== null) {
            if (visible) {
                infoDiv.style.display = 'block'
                
                infoDiv.animate({
                  width: ["0", "100vw"]
                }, {
                  duration: 300,
                  easing: "linear"
                })
              } else {
                infoDiv.animate({
                  width: ["100vw", "0"]
                }, {
                  duration: 300,
                  easing: "linear"
                }).onfinish = () => {
                  infoDiv.style.display = 'none'  // 애니메이션 끝나면 display 속성을 none으로 설정
                }
            }
        }
      }, [curEsti, visible])
    
    const handleClick = (estimate:any) => {
        if(!estimate) setVisible(false)
        else if (estimate?.id === curEsti?.id) {
            setVisible(false)
            setEstimate(null)
        } else {
            if (!visible) setVisible(true)
            setEstimate(estimate)
        }
    }

    const CustomerList = () => {
        return (
            <div className="list">
                <h2>진료요청</h2>
                {/**요청고객 리스트 */}
                <RequestList/>                                 
            </div>
        )
    }

    const RequestList = () =>{
        const isRequestItem = (data:any) => data.status === 'waiting'
        const RequestEstis = estimateList.filter((data)=> isRequestItem(data))

        return (
            <div className="req_list">
                <span className="circle"></span><span className="tit">요청</span>
                <ul>
                    { 
                       RequestEstis.length > 0 ? (
                            RequestEstis.map((esti)=>{
                                return (<li className={`item ${esti.id === curEsti?.id  ? 'on' : ''}`} onClick={()=>handleClick(esti)}><a href="#">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none"><path d="M17.92 13.62C17.8694 13.4988 17.7983 13.3872 17.71 13.29L14.71 10.29C14.5217 10.1017 14.2663 9.99591 14 9.99591C13.7337 9.99591 13.4783 10.1017 13.29 10.29C13.1017 10.4783 12.9959 10.7337 12.9959 11C12.9959 11.2663 13.1017 11.5217 13.29 11.71L14.59 13H9C8.73478 13 8.48043 13.1054 8.29289 13.2929C8.10536 13.4804 8 13.7348 8 14C8 14.2652 8.10536 14.5196 8.29289 14.7071C8.48043 14.8946 8.73478 15 9 15H14.59L13.29 16.29C13.1963 16.383 13.1219 16.4936 13.0711 16.6154C13.0203 16.7373 12.9942 16.868 12.9942 17C12.9942 17.132 13.0203 17.2627 13.0711 17.3846C13.1219 17.5064 13.1963 17.617 13.29 17.71C13.383 17.8037 13.4936 17.8781 13.6154 17.9289C13.7373 17.9797 13.868 18.0058 14 18.0058C14.132 18.0058 14.2627 17.9797 14.3846 17.9289C14.5064 17.8781 14.617 17.8037 14.71 17.71L17.71 14.71C17.8026 14.6161 17.8742 14.5036 17.92 14.38C18.02 14.1365 18.02 13.8635 17.92 13.62ZM11 18H3C2.73478 18 2.48043 17.8946 2.29289 17.7071C2.10536 17.5196 2 17.2652 2 17V3C2 2.73478 2.10536 2.48043 2.29289 2.29289C2.48043 2.10536 2.73478 2 3 2H8V5C8 5.79565 8.31607 6.55871 8.87868 7.12132C9.44129 7.68393 10.2044 8 11 8H15C15.1974 7.99901 15.3901 7.93961 15.5539 7.82928C15.7176 7.71895 15.845 7.56262 15.92 7.38C15.9966 7.19789 16.0175 6.99718 15.9801 6.80319C15.9428 6.6092 15.8488 6.43062 15.71 6.29L9.71 0.29C9.62734 0.212216 9.53282 0.148081 9.43 0.0999999H9.34L9.06 0H3C2.20435 0 1.44129 0.316071 0.87868 0.87868C0.316071 1.44129 0 2.20435 0 3V17C0 17.7956 0.316071 18.5587 0.87868 19.1213C1.44129 19.6839 2.20435 20 3 20H11C11.2652 20 11.5196 19.8946 11.7071 19.7071C11.8946 19.5196 12 19.2652 12 19C12 18.7348 11.8946 18.4804 11.7071 18.2929C11.5196 18.1054 11.2652 18 11 18ZM10 3.41L12.59 6H11C10.7348 6 10.4804 5.89464 10.2929 5.70711C10.1054 5.51957 10 5.26522 10 5V3.41Z" fill="#E0E0E0"/></svg>
                                <span className="name">{esti.userInfo.petName}</span>
                                <span className="gender"> {Object.keys(genderMap).find(key => genderMap[key] === esti?.userInfo?.petGender) ?? "구분없음"} </span>
                                <span className="time">{new Date(esti.createdAt).toLocaleTimeString('ko-KR', {timeZone: 'Asia/Seoul', hour: '2-digit', minute: '2-digit', hour12: false})}</span>
                                </a></li>)
                            })
                        ) :
                        <div>요청 없음</div>
                    }
                </ul>
            </div>
        )
    }

    const createChatID = (createdAt:Date, estimateID:number) => {
        const year = createdAt.getFullYear().toString().slice(-2) // 년도의 마지막 두 자리
        const month = (createdAt.getMonth() + 1).toString().padStart(2, '0') // 월
        const date = createdAt.getDate().toString().padStart(2, '0') // 일
        const hour = createdAt.getHours().toString().padStart(2, '0') // 시
        const minute = createdAt.getMinutes().toString().padStart(2, '0') // 분
      
        const dateStr = `${year}${month}${date}${hour}${minute}`
        return `CHAT_${dateStr}_${estimateID}`
    }

    const CustomerInfo = ({ curEsti }: { curEsti: any }) => {
        const [chatStartMessage, setChatStartMessage] = useState("")
        
        interface ImageContainerProps { imageUrl: string }
        const ImageContainer = ({imageUrl}:ImageContainerProps) => {
            const [src, setSrc] = useState(imageUrl)
            const setDefaultImage = (e:any) => { setSrc(exampleImage)}
            const preventClick = (e:any) => { if(src === "" || src === exampleImage) e.preventDefault()}

            return (<li style={{visibility:src === "" || src === exampleImage ? "hidden" : "visible"}}>      
                <a data-fslightbox href={imageUrl} onClick={preventClick}>
                <img src={src} alt="Image" onError={setDefaultImage}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
                </a>
            </li>)
        }

        const sendEstiProposal = async () => {
            if(!curEsti) return
            if(chatStartMessage === "") return        

            const data = {estimate_id: curEsti.id}

            await axios.post(`${BASEURL}/esti/proposal`, data, { headers: {Authorization: `Bearer ${accessToken}`, }})
            .then(response => response.data)
            .then(async(obj) => {
                if(obj.status === "success") {
                    // refresh this page
                    // make chat room
                    const chatRoomName = `${createChatID(new Date(obj.data.createdAt), obj.data.proposalList.estimateID)}_${obj.data.userID}_${obj.data.proposalList.hospitalID}`

                    await addDoc(collection(db, `estiChat/${chatRoomName}/messages`), {
                        createAt: new Date(),
                        content: chatStartMessage,
                        sender: "Hospital",
                        type: "message"
                    })
                    alert("유저에게 메시지를 전송했습니다.")
                    window.location.reload()
                }
            }).catch(error => {
                if(error.response) {
                    // temp error handling
                    if(error.response.status === 400) alert("이미 보낸 요청입니다.")
                    if(error.response.status === 401) alert("로그인이 만료되었습니다.")
                    if(error.response.status === 403) alert("로그인이 유효하지 않습니다.")
                    if(error.response.status === 404) alert("사용자 정보를 찾을 수 없습니다.")
                }
                else { console.log(error) }
            })
        }
        
        return (
            <div className="info">
                <h2>요청정보</h2>
                <div className="req_box">
                    <div className="basic_info">
                        <div>
                            <span className="tit">반려동물 이름</span>
                            <p><span className="name">{curEsti?.userInfo.petName}</span></p>
                        </div>
                        <div>
                            <span className="tit">나이 / 성별 / 무게</span>
                            <p><span className="age">{curEsti?.userInfo.petAge}개월</span> / <span className="gender">
                            {Object.keys(genderMap).find(key => genderMap[key] === curEsti?.userInfo?.petGender) ?? "구분없음"}</span> / <span className="weight">{curEsti?.userInfo.petWeight}kg</span></p>
                        </div>
                    </div>
                    <div className="basic_info">
                        <div>
                            <span className="tit">보호자 이름</span>
                            <p><span className="p_name">{curEsti?.userInfo.guardianName}</span></p>
                        </div>
                        <div>
                            <span className="tit">전화번호</span>
                            <p><span className="phone">{curEsti?.userInfo.guardianPhoneNumber}</span></p>
                        </div>
                    </div>
                    <div className="detail_info">
                        <div className="img_list">
                            <ul>
                                <ImageContainer imageUrl={curEsti?.content1 ?? ""}/>
                                <ImageContainer imageUrl={curEsti?.content2 ?? ""}/>
                                <ImageContainer imageUrl={curEsti?.content3 ?? ""}/>
                            </ul>
                        </div>
                        <div className="line"></div>
                        <div className="detail">
                            <span className="tit">상세설명</span>
                                <p>{curEsti?.description}</p>
                                <div className="tags">
                            {curEsti?.tagList.map((tag:any)=>{return <div className="tag">{tag}</div>})}
                            
                        </div>
                        </div>
                        
                        <div className="answer_box">
                            <div className="answer">
                                <div className="top">
                                    <span className="tit">답변</span>
                                </div>
                                <div className="bottom">
                                    <textarea name="" id="opinion" cols={30} rows={5}
                                    placeholder="예약 및 상담을 하기 위한 첫 메세지를 입력해주세요." value={chatStartMessage} 
                                    onChange={(e)=>{setChatStartMessage(e.target.value)}}/>
                                </div>
                            </div>
                        </div>                    
                        <button type="button" className="send_btn" onClick={sendEstiProposal}>보내기</button>
                    </div>
                </div>
            </div>
        )
    }

    const CustomerServiceContainer = ()=> {
        return (
            <div className="contents">
                {/** 고객리스트 */}
                <CustomerList/>
                {/** 고객 요청 정보: 기본값은 display none */}
                <CustomerInfo curEsti={curEsti}/>
                {/** 일정 */}
                {/* <CalendarView/> */}
                <CalendarContainer
                    calendarRef={calendarRef}
                    events={events}
                    activeItem={curEsti}/>
            </div>
        )
    }

    return (<CustomerServiceContainer/>)
}

export default MainPage
